module.exports = __webpack_public_path__ + "static/media/cluster_3.d942b3f4.webp";